'use strict';
(()=>{
 const dictionary=window.BABA_FA||{};
 const serverLanguage=window.BABA_INITIAL_LANGUAGE||document.documentElement.lang;
 let language=serverLanguage==='fa'?'fa':'en';
 const number=text=>text.replace(/[0-9]/g,d=>'۰۱۲۳۴۵۶۷۸۹'[Number(d)]);
 const textRecords=new WeakMap(),attributeRecords=new WeakMap();
 function translate(source){
  const value=String(source??'');
  if(language!=='fa')return value;
  const trimmed=value.trim();
  if(!trimmed)return value;
  const result=dictionary[trimmed]??(/^[\d\s/:.]+$/.test(trimmed)?number(trimmed):trimmed);
  return value.slice(0,value.indexOf(trimmed))+result+value.slice(value.indexOf(trimmed)+trimmed.length);
 }
 function excluded(element){return !element||element.closest('script,style,noscript,textarea,[data-no-translate]');}
 function sourceValue(node,key,current,records){
  let record=records.get(key);
  if(!record||current!==record.source&&current!==record.rendered)record={source:current,rendered:current};
  record.rendered=translate(record.source);records.set(key,record);return record.rendered;
 }
 function applyTranslations(){
  observer.disconnect();
  const walker=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT);let node;
  while((node=walker.nextNode())){
   if(excluded(node.parentElement))continue;
   const records=textRecords.get(node)||new Map();textRecords.set(node,records);
   const rendered=sourceValue(node,'text',node.nodeValue,records);
   if(node.nodeValue!==rendered)node.nodeValue=rendered;
  }
  document.querySelectorAll('[aria-label],[alt],[placeholder],[title]').forEach(element=>{
   if(excluded(element))return;
   const records=attributeRecords.get(element)||new Map();attributeRecords.set(element,records);
   for(const attr of ['aria-label','alt','placeholder','title'])if(element.hasAttribute(attr)){
    const current=element.getAttribute(attr),rendered=sourceValue(element,attr,current,records);
    if(current!==rendered)element.setAttribute(attr,rendered);
   }
  });
  observer.observe(document.body,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['aria-label','alt','placeholder','title']});
 }
 const observer=new MutationObserver(applyTranslations);
 function localeURL(next){
  const url=new URL(location.href);
  url.pathname=next==='fa'?'/fa':'/';return url;
 }
 function setLanguage(next){
  next=next==='fa'?'fa':'en';
  if(next!==language){location.assign(localeURL(next).href);return;}
  document.documentElement.lang=language;
  document.documentElement.dir=language==='fa'?'rtl':'ltr';
  try{localStorage.setItem('baba-language',language);}catch{}
  applyTranslations();document.dispatchEvent(new Event('baba-language-change'));
 }
 window.BabaI18n={get language(){return language;},translate,setLanguage};
 const link=document.querySelector('#language-toggle');
 if(link){
  const target=new URL(link.href,location.href);target.search=location.search;target.hash=location.hash;link.href=target.href;
  link.addEventListener('click',()=>{const target=new URL(link.href,location.href);target.search=location.search;target.hash=location.hash;link.href=target.href;});
 }
 document.addEventListener('invalid',event=>{
  const input=event.target;
  if(language!=='fa'||typeof input.setCustomValidity!=='function')return;
  input.setCustomValidity(input.validity.typeMismatch?translate('Enter a valid email address.'):input.type==='checkbox'?translate('Please confirm your choice.'):translate('Please fill out this field.'));
 },true);
 document.addEventListener('input',event=>event.target.setCustomValidity?.(''));
 setLanguage(language);
})();
